import { render, staticRenderFns } from "./IconGlobeAltOutline.vue?vue&type=template&id=7ae4f9bb"
import script from "./IconGlobeAltOutline.vue?vue&type=script&lang=js"
export * from "./IconGlobeAltOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports